export default __webpack_public_path__ + "static/media/kitchen-pack-8.ff311c1d.png";